import { Grid } from "@mui/material";
import { useEffect, useReducer, useRef } from "react"
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert"
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer"
import TechLeadControlService from "./TechLeadControlService"
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import DefaultChip from '../../componentes/chip/DefaultChip';
import { Typography } from "@material-ui/core";

/**
 * Author : AndréK
 * 26/08/2022
*/
const columnsTechLead = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "techLeadName",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="techLeadName" name="company" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standart"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.techLeadName}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "crf",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="crf" name="company" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standart"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.crf}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const TechLeadRegister = ({ updateId }) => {

    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");
    const crfRef = useRef(null);
    const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);

    const initialState = {
        id: 0,
        idClient: loggedIdClient !== 0 ? loggedIdClient : 0,
        clientName: "",
        techLeadName: "",
        crf: "",
        techLeadRows: [],
        loggedUserId: userId,
        status: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }


    const [TechLeadControl, dispatch] = useReducer(reducer, initialState);

    const { id, techLeadName, idClient, crf, status } = TechLeadControl
    const { success, error, techLeadRows, ...data } = TechLeadControl

    useEffect(() => {
        updateId({ id: id })
    }, [id])

    const regex = /^[A-Z]{2}\d{5,14}$/;
    const handleChange = (event) => {
        const { name, value } = event.target;

        if (name === "crf") {
            dispatch({
                type: "update",
                data: { crf: value, crfValido: regex.test(value) }
            });
            return;
        }

        dispatch({ type: "update", data: { [name]: value } });
    };

    const handleSearch = () => {
        TechLeadControlService
            .getTechLead(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { techLeadRows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { techLeadRows: [] } }));
    }
    const canSave = () => techLeadName !== "" && status !== 2;

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                TechLeadControlService
                    .updateTechLead(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                TechLeadControlService
                    .createTechLead(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id, message: t("noDataExport") } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }

    }

    const handleCellClickTechLead = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                idClient: data.idClient,
                techLeadName: data.techLeadName,
                clientName: data.clientName,
                status: data.status,
                crf: data.crf,
            }
        })
    }

    const handleReloadImg = () => {
        TechLeadControlService
            .getTechLead(data)
            .then((response) => {
                if (response.status === 200) {
                    const rows = []
                    response.data.forEach(item => {
                        rows.push({
                            id: item.id,
                            techLeadName: item.techLeadName,
                            clientName: item.clientName,
                            idClient: item.idClient,
                            crf: item.crf,
                            status: item.status
                        });
                    });
                    dispatch({ type: 'update', data: { ...rows[0], techLeadRows: rows } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { techLeadRows: [] } }));
    }

    useEffect(() => {
        handleSearch();
    }, [])

    return (
        <>
            <DefaultScreenAccordion
                title={t("techlead")}
                isRegister
                fields={
                    <GridItemContainer>
                        <CustomAlert
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <Grid item xs={id !== 0 ? 7 : 12} sm={id !== 0 ? 8 : 12} md={id !== 0 ? 10 : 12}>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={3}>
                                    <div style={{
                                        pointerEvents: loggedIdClient !== 0 ? "none" : "auto",
                                        opacity: loggedIdClient !== 0 ? 0.8 : 1
                                    }}>

                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name={loggedIdClient !== 0 ? "unLock" : "user"}
                                                    labelName="client"
                                                />
                                            }
                                            name="idClient"
                                            onChange={loggedIdClient !== 0 ? undefined : handleChange}
                                            disabled={loggedIdClient !== 0}
                                            value={idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClient'
                                            error={error && idClient === 0}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="company" labelName="techLeadName" />
                                        }
                                        name="techLeadName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={techLeadName}
                                        inputProps={{ maxLength: 50 }}
                                        error={error && techLeadName === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        inputRef={crfRef}
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="crf" labelName="crf" />
                                        }
                                        name="crf"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        mask="CRBio-9:99999/99-a"
                                        value={crf}
                                        inputProps={{ maxLength: 18 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && status === 2}
                                    />
                                </Grid>
                            </GridInputRow>
                        </Grid>

                        <SearchClearSaveRow
                            onClickSearch={handleSearch}
                            onClickClear={() => dispatch({ type: 'clear' })}
                            onClickSave={handleSaveUpdate}
                        />
                        {(techLeadRows.length > 0) ? (
                            <GridInputRow>
                                <Grid item xs={12}>
                                    <DefaultDatagrid
                                        columns={columnsTechLead(t)}
                                        dataSource={techLeadRows}
                                        allowPaging={true}
                                        cellSelected={(args, grid) =>
                                            handleCellClickTechLead(args.data)
                                        } />
                                </Grid>
                            </GridInputRow>
                        ) : null}
                    </GridItemContainer>
                } />
        </>
    );
}